import styled from "styled-components";

const DialogBackground = styled.div`
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    z-index: 1060;
    display: flex;
    justify-content: center;
    align-items: center;
`;

const Dialog = styled.div<{ width?: number; height?: number }>`
    position: fixed;
    background-color: white;
    width: ${({ width }) => (width ? `${width}px` : "400px")};
    height: ${({ height }) => (height ? `${height}px` : "auto")};
    border-radius: 5px;
    padding: 20px;
    z-index: 1061;
    border-radius: 24px;
    text-align: center;
    background: #f0f2f2;
    box-shadow: 0 1rem 3rem rgb(0 0 0 / 18%);
    border: 1px solid rgba(0, 0, 0, 0.175);
    outline: none;
`;

const DialogHeader = styled.div`
    display: flex;
    flex-shrink: 0;
    align-items: center;
    justify-content: flex-end;
    /* padding: 1rem 1rem; */
    border-top-left-radius: calc(0.5rem - 1px);
    border-top-right-radius: calc(0.5rem - 1px);
    border-bottom: none;
    .btn-close {
        font-size: 10px;
        padding: 0.5rem 0.5rem;
        margin: -0.5rem -0.5rem -0.5rem auto;
        &:focus {
            box-shadow: none;
        }
    }
`;

const DialogBody = styled.div`
    position: relative;
    flex: 1 1 auto;
    padding: 1rem 1rem;
`;

const DialogTitle = styled.h4`
    font-weight: 700;
    font-size: 24px;
    line-height: 130%;
    color: #1e1e1e;
`;

const DialogText = styled.h4`
    text-align: center;
    font-weight: 400;
    font-size: 17px;
    line-height: 150%;
    margin: 24px 0;
    padding: 20px 0;
`;

const DialogButtonWrapper = styled.div`
    display: flex;
    justify-content: center;
    margin-top: 1rem;
    button {
        font-size: 16px;
        display: -webkit-box;
        display: -webkit-flex;
        display: -ms-flexbox;
        display: flex;
        align-items: center;
        justify-content: center;
        min-width: 110px;
        min-height: 48px;
        padding: 8px 18px 8px 18px;
        border-radius: 24px;
        box-shadow: none;
        cursor: pointer;
    }
`;

const DialogAcceptButton = styled.button`
    color: #fff;
    background: #8a0538;
    border: 1px solid #8a0538;
    border-radius: 24px;
`;

const DialogCancelButton = styled.button`
    color: #8a0538;
    background: transparent;
    border: none;
`;

export {
    DialogBackground,
    Dialog,
    DialogHeader,
    DialogBody,
    DialogTitle,
    DialogText,
    DialogButtonWrapper,
    DialogAcceptButton,
    DialogCancelButton,
};
